import { useEffect, useMemo } from "react"
import { Outlet } from "react-router"

import { useSettingsData } from "@/queries/queries"
import { useStore } from "@/zustand/store"

import styles from "./AuthLayout.module.css"

export default function AuthLayout() {
  const { setPrimaryColor, setSecondaryColor, setBrandingAssets } = useStore(
    (state) => state
  )
  const settingsQuery = useSettingsData()
  useEffect(() => {
    if (settingsQuery.data && Array.isArray(settingsQuery.data)) {
      const primaryColor = settingsQuery.data.find(
        (item) => item.key === "primary_color"
      )?.value
      const secondaryColor = settingsQuery.data.find(
        (item) => item.key === "secondary_color"
      )?.value

      setPrimaryColor(primaryColor || "")
      setSecondaryColor(secondaryColor || "")

      const siteLogo =
        settingsQuery.data.find((item) => item.key === "site_logo")?.value || ""
      const favicon =
        settingsQuery.data.find((item) => item.key === "site_favicon")?.value ||
        ""
      const loginLogo =
        settingsQuery.data.find((item) => item.key === "login_logo")?.value ||
        ""
      const siteTitle =
        settingsQuery.data.find((item) => item.key === "site_name")?.value || ""

      setBrandingAssets({ siteLogo, favicon, loginLogo, siteTitle })
    }
  }, [
    settingsQuery.data,
    setPrimaryColor,
    setSecondaryColor,
    setBrandingAssets,
  ])

  const image = useMemo(() => {
    if (!settingsQuery.data?.length) return ""
    return settingsQuery.data?.filter((ele) => ele?.key === "logo_student")[0]
      ?.value
  }, [settingsQuery.data])

  return (
    <div className={styles.auth__page}>
      {/* <div
        className="ramadan-page-decoration position-absolute top-0 "
        style={{
          height: "150px",
        }}
      /> */}
      {/* <div
        className="d-none d-md-block"
        style={{
          height: "400px",
          width: "500px",
          position: "relative",
        }}
      >
        <img
          src="/assets/images/ramadan/fanos.png"
          style={{
            width: "100%",
            position: "absolute",
            bottom: "-20%",
            left: "-10%",
          }}
        />
        <img
          src="/assets/images/ramadan/ramadan-mubarak.png"
          style={{
            width: "50%",
            position: "absolute",
            top: "-10%",
            right: "-5%",
          }}
        />
      </div> */}
      <div className={styles.img__con}>
        <img
          className="w-100 object-fit-contain"
          src={image}
          alt="dashboard-logo"
        />
      </div>
      <div className={styles.auth__form}>
        <Outlet />
      </div>
      {/* <div
        // hide on large screen using bootstrap
        className="d-block d-md-none"
        style={{
          height: "300px",
          width: "350px",
          position: "relative",
        }}
      >
        <img
          src="/assets/images/ramadan/fanos.png"
          style={{
            width: "100%",
            position: "absolute",
            bottom: "-20%",
            left: "-10%",
          }}
        />
        <img
          src="/assets/images/ramadan/ramadan-mubarak.png"
          style={{
            width: "50%",
            position: "absolute",
            top: "-10%",
            right: "-5%",
          }}
        />
      </div> */}
    </div>
  )
}
